import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { State } from '../../State';
import { getContractOptionsFetched } from '../../State/selectors/mdqx/selectors';
import { GetContractOptionsRequest } from '../../State/actions/mdqx/contract-options.actions';
@Injectable({
    providedIn: 'root',
})
export class ContractOptionsResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getContractOptionsFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetContractOptionsRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
